import { CalendarClock } from 'lucide-react'
import type { PropostaValidityInfo } from '@/utils/propostaPublicaUtils'

type Props = {
  validity: PropostaValidityInfo
}

export function PropostaPublicaHeaderStatus({ validity }: Props) {
  const daysLabel =
    validity.daysRemaining <= 0
      ? 'Expira hoje'
      : validity.daysRemaining === 1
        ? '1 dia restante'
        : `${validity.daysRemaining} dias restantes`

  return (
    <div className="flex flex-col items-end gap-1.5 shrink-0 text-right">
      <div className="flex items-center gap-1.5 text-[10px] text-[var(--text-muted)]">
        <CalendarClock size={12} className="shrink-0 text-[var(--brand-primary)]" aria-hidden />
        <span>
          Válida até <span className="text-[var(--text-primary)]">{validity.expiresAtLabel}</span>
          <span className="hidden sm:inline"> · </span>
          <span className="block sm:inline text-[var(--text-secondary)]">{daysLabel}</span>
        </span>
      </div>
    </div>
  )
}
